<template>
  <div>
    <div class="d-flex">
      <div>
        <span style="font-size: 16px; color: #606266" class="mr-4">
          {{ $l('INDEX.table_label_channel_name') || '店铺' }}：{{
            formData.platformName
          }}
        </span>
        <span style="font-size: 16px; color: #606266">
          {{ $l('form_label_region') || '市场' }}：{{ formData.regionName }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      size="small"
      :rules="rules"
      :model="formData"
      :disabled="disabled"
    >
      <el-row :gutter="20" class="mt-3">
        <el-col :span="12">
          <el-form-item :label="$l('table_label_hxSkuNo') || '产品SKU编号'">
            <el-input v-model="formData.hxSkuNo" disabled clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_channelItemNo') || '渠道Item号'"
            prop="channelItemNo"
          >
            <el-input
              v-model="formData.channelItemNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_channelEanNo') || '渠道条码号'"
            prop="channelEanNo"
          >
            <el-input
              v-model="formData.channelEanNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_brand') || '品牌'"
            prop="brandCode"
          >
            <dict-select
              v-model="formData.brandCode"
              :selectedLabel.sync="formData.brandName"
              url="/master/common/dict/brandSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_sellableEachQty') || '最小出货入数'"
            prop="sellableEachQty"
          >
            <el-input-number
              v-model="formData.sellableEachQty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              clearable
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_sellableEachUnit') || '最小出货单位'"
            prop="sellableEachUnit"
          >
            <dict-select
              v-model="formData.sellableEachUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sellableEachUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_salesPrice') || '结算价格'"
            prop="salesPrice"
          >
            <el-input-number
              v-model="formData.salesPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :min="0"
              :step="0.01"
              :precision="4"
              controls-position="right"
              style="width: 100%"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_salesCurrencyUnit') || '结算货币单位'"
            prop="salesCurrencyUnit"
          >
            <dict-select
              v-model="formData.salesCurrencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_salesTitle') || '店铺售卖标题'"
            prop="salesTitle"
          >
            <el-input
              v-model="formData.salesTitle"
              clearable
              maxlength="1000"
              type="textarea"
              rows="2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    platformCode: { type: String, default: '' },
    hxSkuPlatformCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      currencyUnitParams: { dictType: 'currencyUnit' },
      rules: {
        channelItemNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        channelEanNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        salesPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            type: 'number',
            min: 0.1,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        // salesTitle: [
        //   {
        //     required: true,
        //     trigger: 'change',
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
        //   },
        // ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.platformCode || !this.hxSkuPlatformCode) return
      const res = await this.$api
        .ecomHxSkuPlatformListingDetailApi({
          platformCode: this.platformCode,
          hxSkuPlatformCode: this.hxSkuPlatformCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxSkuPlatformListingSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
